/* eslint-disable */
// AWS Amplify v6 configuration (ResourcesConfig shape).

const amplifyConfig = {
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID as string,
      userPoolClientId: process.env.REACT_APP_COGNITO_WEB_CLIENT_ID as string,
      loginWith: {
        oauth: {
          domain: process.env.REACT_APP_COGNITO_DOMAIN as string,
          scopes: [
            'phone',
            'email',
            'openid',
            'profile',
            'aws.cognito.signin.user.admin',
          ],
          redirectSignIn: [
            process.env.REACT_APP_COGNITO_REDIRECT_SIGN_IN_URL as string,
          ],
          redirectSignOut: [
            process.env.REACT_APP_COGNITO_REDIRECT_SIGN_OUT_URL as string,
          ],
          responseType: 'code' as const,
        },
      },
    },
  },
};

export default amplifyConfig;
